import { ZfStack } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useState } from 'react';
import { useClient } from '../api';
import { ClientBar, DashboardBanners, TopicGrid, TopicTiles } from '../components/dashboard';
import { ClientCurrencyModal } from '../components/modal';
import { useYwuApp } from '../contexts/ywu-app-context';
import { useContainerDimensions } from '../hooks/useContainerDimensions';

export const DashboardActiveSession: FunctionComponent = () => {
    const containerDimensions = useContainerDimensions();
    const { data: client } = useClient();
    const { isPresentationMode } = useYwuApp();
    const [wnInfoBannerHeight, setWnInfoBannerHeight] = useState(0);

    return (
        <ZfStack direction="column" justify="center" style={{ flex: 1, backgroundColor: 'var(--bg-color-default-muted)' }}>
            <DashboardBanners onBannerHeightChange={setWnInfoBannerHeight} />
            <TopicGrid
                height={containerDimensions.height}
                width={containerDimensions.width}
                isPresentationMode={isPresentationMode}
                wnInfoBannerHeight={wnInfoBannerHeight}
            >
                <ClientBar />
                <TopicTiles height={containerDimensions.height - wnInfoBannerHeight} width={containerDimensions.width} showUpcomingEvents={true} />
                {!client?.currency && <ClientCurrencyModal />}
            </TopicGrid>
        </ZfStack>
    );
};
